import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  user: {},
  exp: -1,
  login: null,
  userLoadStatus: 0,
  list: [],
  current_filters: {}
};

// getters
const getters = {
  getSession(state) {
    return { user: state.user, exp: state.exp, login: state.login };
  },
  /*
        Returns the user load status.
    */
  getUserLoadStatus(state) {
    return function() {
      return state.userLoadStatus;
    };
  },

  getUser(state) {
    return state.user;
  },

  getList: state => id => {
    if (typeof id !== "undefined") return state.list[id];

    // var aUsers = [ { id: null, name: "Sense asignar" } ];
    var aUsers = [];
    for (var i in state.list) {
      // if( state.list[ i ] ) aUsers.push( state.list[ i ] );
      if (typeof state.list[i].visible === "undefined" || state.list[i].visible)
        aUsers.push(state.list[i]);
    }
    return aUsers;
  },

  getTotalList: (state, getters, rootState) => () => {
    return Object.keys(state.list).length;
  },

  getListFilters: state => () => {
    var aUsers = [{ id: null, name: "Sense asignar" }];
    for (var i in state.list) {
      var tp = parseInt(state.list[i].type, 10);
      var isGestorBo =
        tp === 1 ||
        tp === 2 ||
        (tp >= 1001 && tp <= 1016);
      if (
        isGestorBo &&
        (typeof state.list[i].visible === "undefined" || state.list[i].visible)
      ) {
        aUsers.push(state.list[i]);
      }
    }

    return aUsers;
  },

  getListNoFiltered: (state, getters, rootState) => () => {
    var aUsers = [];
    for (var i in state.list) {
      aUsers.push(state.list[i]);
    }
    return aUsers;
  },

  get_by_id: (state, getters, rootState) => id => {
    if (typeof state.list[id] !== "undefined") {
      var user = { ...state.list[id] };
      for (var k in user) {
        if (user[k] == "true") user[k] = true;
        else if (user[k] == "false") user[k] = false;
        else if (parseInt(user[k]) == user[k]) user[k] = parseInt(user[k]);
      }

      return user;
    }
    return false;
  }
};

function buildUserListQuery(filters) {
  if (!filters) {
    return "";
  }
  var q = [];
  if (
    filters.type != null &&
    filters.type !== "" &&
    parseInt(filters.type, 10) !== -1
  ) {
    q.push("type=" + encodeURIComponent(filters.type));
  }
  var st = filters.status;
  if (typeof st === "boolean") {
    st = st ? 1 : 0;
  }
  if (st !== undefined && st !== null && st !== "" && parseInt(st, 10) !== -1) {
    var si = parseInt(st, 10);
    if (si === 1 || si === -2) {
      q.push("status=" + encodeURIComponent(si));
    }
  }
  if (filters.name != null && String(filters.name).trim() !== "") {
    q.push("name=" + encodeURIComponent(String(filters.name).trim()));
  }
  return q.length ? "?" + q.join("&") : "";
}

const actions = {
  loadList({ commit, state }, params) {
    var filters =
      params && params.filters ? params.filters : state.current_filters;
    var path = "user" + buildUserListQuery(filters);
    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        for (var i in data) {
          data[i].visible = true;
        }

        return commit("setList", data);
      }
    });
  },

  load_by_id({ commit }, params) {
    var path = "user/" + params.id;
    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        return commit("addUser", data);
      }
    });
  },

  upload(context, data) {
    var user = { ...data.data };
    user.event = data.event;
    var params = data.params;
    var path =
      typeof user.id !== "undefined"
        ? "user/" + user.id + "/update"
        : "user/add";
    return api.post(path, user).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        context.commit("addUser", data);
        return data.id;
      }
    });
  },

  remove(context, id) {
    return api.post("user/" + id + "/remove", {}).then(function(response) {
      if (response.status) {
        context.commit("removeUser", id);
      }
      return response;
    });
  },

  setStatus(context, { id, status }) {
    return api.post("user/" + id + "/status", { status: status }).then(
      function(response) {
        if (response.status && response.data) {
          context.commit("patchUserStatus", {
            id: response.data.id,
            status: response.data.status
          });
        }
        return response;
      }
    );
  }
};
const mutations = {
  setAuthenticate(state, data) {
    //console.log("setAuthenticate");
    if (!data) {
      state = {
        user: {},
        exp: -1,
        login: null,
        userLoadStatus: 0
      };
    } else {
      data.user.avatar = "/img/user_w.svg";
      state.user = data.user;
      state.user.letter = data.user.name.substring(0, 1).toUpperCase();
      state.exp = data.exp;
      state.login = moment();
      state.userLoadStatus = 2;
      state.user.token = data.token;

      // CHAT NOW DISABLED
      // smartsupp('name', data.user.name );
      // smartsupp('email', data.user.email );
      // smartsupp('variables', data.user );

      // To set unique user id in your system when it is available
      // window.fcWidget.setExternalId( data.user.id );
      // // To set user name
      // window.fcWidget.user.setFirstName( data.user.name );
      // // To set user email
      // window.fcWidget.user.setEmail( data.user.email );
      // // To set user properties
      // window.fcWidget.user.setProperties( data.user );
    }
    return true;
  },

  logoutUser(state) {
    state = {
      user: {},
      exp: -1,
      login: null,
      userLoadStatus: 0
    };

    localStorage.removeItem("token");
  },

  setList(state, data) {
    state.list = data;
  },

  addUser(state, user) {
    var list = { ...state.list };
    list[user.id] = user;

    state.list = list;
  },

  removeUser(state, id) {
    var list = { ...state.list };
    delete list[id];
    state.list = list;
  },

  patchUserStatus(state, { id, status }) {
    var list = { ...state.list };
    if (typeof list[id] !== "undefined") {
      list[id] = { ...list[id], status: status, visible: list[id].visible };
    }
    state.list = list;
  },

  applyFilters(state, filters) {
    state.current_filters = filters ? { ...filters } : {};
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
